export default function NotFound() {
  return (
    <div className="relative flex items-center justify-center min-h-screen bg-white text-gray-900 overflow-hidden">
      
      {/* Soft animated background blobs */}
      <div className="absolute w-[400px] h-[400px] bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-pulse top-[-100px] left-[-100px]" />
      <div className="absolute w-[400px] h-[400px] bg-pink-200 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-pulse bottom-[-100px] right-[-100px]" />

      {/* Content */}
      <div className="relative z-10 text-center px-6">
        
        {/* 404 Heading */}
        <h1 className="text-8xl md:text-9xl font-extrabold bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500 bg-clip-text text-transparent animate-fade-in">
          404
        </h1>

        {/* Message */}
        <p className="mt-6 text-lg md:text-xl text-gray-600 animate-fade-in delay-200">
          Oops! The page you’re looking for doesn’t exist.
        </p>

        {/* Subtext */}
        <p className="mt-2 text-sm text-gray-400 animate-fade-in delay-300">
          It might have been moved, deleted, or never existed.
        </p>

        {/* Buttons */}
        <div className="mt-8 flex justify-center gap-4 animate-fade-in delay-500">
          <a
            href="/"
            className="px-6 py-3 rounded-2xl bg-gradient-to-r from-blue-500 to-indigo-500 text-white font-semibold shadow-md hover:scale-105 transition-transform duration-300"
          >
            Go Home
          </a>

          <button
            onClick={() => window.history.back()}
            className="px-6 py-3 rounded-2xl border border-gray-300 text-gray-700 hover:bg-gray-100 transition-all duration-300"
          >
            Go Back
          </button>
        </div>
      </div>

      {/* Floating particles */}
      <div className="absolute inset-0 pointer-events-none">
        {[...Array(15)].map((_, i) => (
          <span
            key={i}
            className="absolute w-1 h-1 bg-gray-400 opacity-30 rounded-full animate-float"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
}